const custom_data_collections = [
    'users',
    'contacts',
    'cases',
]

export default custom_data_collections;